<template lang="pug">
App(:navigationItems="navigationItems" :cartPrefix="CartPrefix.TAKEAWAY_ON_SITE" :defaultSaletype="Saletype.TAKEAWAY_ON_SITE")
  AgeRestrictionDialog(v-if="isAgeRestrictionEnabled")
</template>

<script setup lang="ts">
import App from "@/App.vue";
import AgeRestrictionDialog from "@/components/modals/AgeRestrictionDialog.vue";
import { Saletype } from "@/models/App";
import { CartPrefix } from "@/models/Cart";
import { useApp } from "@/store/app";
import { useRecaptchaProvider } from 'vue-recaptcha/head';
import type { NavigationItem } from "@/types";
import { computed } from "vue";
import { inject } from "vue";
import type { Auth } from "@/plugins/auth";
import { useRouter, type RouteLocationRaw } from "vue-router";
import type { Ref } from "vue";

useRecaptchaProvider();

const auth = inject('auth') as Ref<Auth>;
const router = useRouter();
const { isAuthenticationEnabled, isAgeRestrictionEnabled } = useApp();

router.beforeEach((to, from, next) => {
  let redirectRoute: RouteLocationRaw|undefined;
  if (to.meta && to.meta.auth) {
    if (!auth.value.check()) {
      if (from.name !== "auth.login") {
        redirectRoute = { name: "auth.login", query: { afterLogin: to.name as string } };
      } else redirectRoute = { name: "order" };
    }
  }
  redirectRoute ? next(redirectRoute) : next();
});

const navigationItems = computed((): NavigationItem[] => {
  const items: NavigationItem[] = [
    {
      icon: "$orderLight",
      activeIcon: "$orderBold",
      link: { name: "order" },
      name: "app.navigation.order"
    },
    {
      icon: "$cartLight",
      activeIcon: "$cartBold",
      link: { name: "cart" },
      name: "app.navigation.cart"
    }
  ];
  if(isAuthenticationEnabled.value) {
    items.push({
        icon: "$peopleLight",
        activeIcon: "$peopleBold",
        link: { name: "user" },
        name: "app.navigation.account"
      });
  }
  return items;
});
</script>
